<template>
  <div class="vx-row">
    <div class="vx-col w-full">
      <vx-card>
        <template slot="actions">
        </template>
        <ValidationObserver ref="form" v-slot="{ handleSubmit }">
          <form id="task-view" @submit.prevent="handleSubmit(onClickUpdateTask)" autocomplete="off">
            <div class="vx-row mb-3">
              <div class="vx-col md:w-1/3 md:mb-0">
                <vs-input v-model="form.name" label="Name" class="w-full" placeholder="Enter task name" />
              </div>
              <div class="vx-col md:w-1/3 md:mb-0" v-if="!form.allocation">
                <small class="label">Department</small>
                <v-select name="department" v-model="form.departments" :options="departments" label="name"
                  :reduce="dept => dept.id" placeholder="Select Department" multiple :closeOnSelect="false" />
              </div>
              <div class="vx-col md:w-1/3 md:mb-0">
                <small class="label">Frequency</small>
                <v-select name="frequencies" v-model="form.frequency" :options="frequencies"
                  :reduce="option => option.value" class="w-full">

                </v-select>

              </div>
            </div>
            <div class="vx-row mb-3">
              <div class="vx-col md:w-1/3 md:mb-0" v-if="!form.allocation">
                <small class="label">Assigned To</small>
                <v-select :clearable="false" :searchable="true" :key="'staff-dropdown'" @search="onSearch"
                  name="assignee" placeholder="" label="name" v-model="form.staff" :reduce="option => option.id"
                  multiple :closeOnSelect="false" :options="staffs" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                  <template slot="no-options">
                    type to search staff
                  </template>
                </v-select>
              </div>
              <div class="vx-col md:w-1/3 md:mb-0">
                <small class="label">Task Template</small>
                <v-select :clearable="false" :searchable="true" :key="'template-dropdown'" @search="onSearchTemplate"
                  name="scheduled_task_template" placeholder="" label="name" v-model="form.scheduled_task_template"
                  :reduce="option => option.id" :options="taskTemplates" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                  <template slot="no-options-template">
                    type to search templates
                  </template>
                </v-select>
              </div>
              <div class="vx-col md:w-1/6 md:mb-0">
                <small class="label">Start Date</small>
                <flat-pickr class="w-full" :config="flatPkrConfig" v-model="form.start_date"
                  placeholder="Choose Date" />
              </div>
              <div class="vx-col md:w-1/6 md:mb-0">
                <small class="label flex items-center">No End Date <vs-checkbox class="pb-1"
                    style="margin-top: -0.25rem !important;" v-model="perpetual"></vs-checkbox></small>
                <flat-pickr v-if="perpetual == false" class="w-full" :config="flatPkrConfig" v-model="form.end_date"
                  placeholder="Choose Date" />
              </div>
            </div>
            <div v-if="form.allocation != null" class="vx-row mb-3">
              <div class="vx-col md:w-1/3 w-full md:mb-0">
                <small class="label">Area</small>
                <v-select :clearable="false" name="allocations" v-model="form.allocation" :options=allocations
                  :reduce="option => option.value" placeholder="Select Allocation" />
              </div>
              <div class="vx-col md:w-2/3 w-full md:mb-0 vx-card card-border py-2" v-if="form.allocation === 'Work Order'">
                <small>Event Trigger (when)</small>
                <div class="vx-row">
                  <div class="vx-col md:w-1/2 w-full md:mb-0">
                    <small class="label">Status is</small>
                    <v-select name="event" v-model="form.allocation_event" :options=event_status[form.allocation]
                      :closeOnSelect="true" />
                  </div>
                  <div class="vx-col md:w-1/2 w-full md:mb-0">
                    <small class="label">FG Type is</small>
                    <v-select name="event" v-model="form.allocation_optional"
                      :options=event_allocation_optional[form.allocation] :closeOnSelect="true" />
                  </div>
                </div>
              </div>
            </div>
            <div class="mb-3 vx-row">
              <div class="w-full vx-col md:w-full md:mb-0">
                <small class="label">Notes</small>
                <vs-textarea v-model="form.notes" :rows="5"></vs-textarea>
              </div>
            </div>
            <div class="flex flex-wrap items-center justify-end mt-8">
              <vs-button button="submit" class="mt-2 ml-auto">Save Changes</vs-button>
            </div>
          </form>
        </ValidationObserver>
      </vx-card>
    </div>
  </div>
</template>

<script>
import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'
import vSelect from "vue-select";
import { RepositoryFactory } from '@/repository/RepositoryFactory'
const DepartmentsRepository = RepositoryFactory.get('departments')
const ScheduledTasksRepository = RepositoryFactory.get('scheduled_tasks');
const DropDownRepository = RepositoryFactory.get('drop_down');
import flatPickr from "vue-flatpickr-component";
import RangeScale from '../../../components/range-scale/rangeScale.vue';
export default {
  name: "task-view",
  components: {
    'v-select': vSelect,
    flatPickr,
    RangeScale
  },
  data: function () {
    return {
      id: '',
      form: {
        name: '',
        description: '',
        departments:[],
        frequency: '',
        allocation: '',
        signoff_required: true,
      },
      perpetual: null,
      frequencies: [],
      taskTemplates: [],
      staffs: [],
      departments: [],
      dataLoaded: false,
      event_status: {
        'Work Order': ['Open', 'Confirmed', 'Paused', 'Cancelled', 'In Progress', 'Stopped', 'Mix Completed', 'Pack Off In Progress', 'Pack Off Completed']
      },
      event_allocation_optional: {
        'Work Order': ['Liquid', 'Powder', 'Spray Dry Powder', 'Fruit']
      }
    }
  },
  mixins: [SuccessMessage, ErrorMessages],
  async mounted() {
    this.id = this.$route.params.id
    await this.fetchTaskDetails();
    await this.getFrequencies();
    await this.getAllocations();
    await this.getDepartments();
    let deptsToSearch = this.form.departments.map(item => {
        if(item.id){
          return item.id
        }
        else {
        return item
        }
      })
    await this.getStaffList(deptsToSearch); 

    const { data: taskResponse } = await ScheduledTasksRepository.getTemplates(`filter[status]=Published`);
    this.taskTemplates = taskResponse.data;
  },
  methods: {
    searchStaff: _.debounce(async (loading, search, vm) => {
      loading(true);

      // Read departments from your form
      let deptsToSearch = vm.form.departments.map(item => {
      if(item.id){
        return item.id
      }
      else {
      return item
      }
      })
      const deptIds = Array.isArray(deptsToSearch)
        ? deptsToSearch.join(',')
        : '';

      let query = `filter[search]=${search}&filter[is_active]=1`;

      if (deptIds) {
        query += `&filter[department-ids]=${deptIds}`;
      }

      const { data } = await DropDownRepository.getStaffList(query);

      vm.staffs = data.data;
      loading(false);
    }, 350),
    searchTemplates: _.debounce(async (loading, search, vm) => {
      const { data } = await ScheduledTasksRepository.getTemplates(`filter[search]=${search}&filter[status]=Published`)
      vm.taskTemplates = data.data
      loading(false);
    }, 350),
    async fetchTaskDetails() {
      await this.$vs.loading({
        container: '#task-view',
        scale: 0.45
      })
      try {
        const { data } = (await ScheduledTasksRepository.getTask(this.id)).data
        this.form = data
        this.form.staff = data.staff;
        this.form.scheduled_task_template = data.scheduled_task_template;
        if (this.form.end_date == null) {
          this.perpetual = true;
        }
        else {
          this.perpetual = false;
        }
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close('#task-view > .con-vs-loading')
    },
    async onClickUpdateTask() {
      const vue = this;
      await this.$vs.loading({
        container: '#task-view',
        scale: 0.45
      })
      try {
        let payload = {
          ...this.form,
          staff: this.toIds(this.form.staff),
          departments: this.toIds(this.form.departments)
        }
        await ScheduledTasksRepository.updateTask(this.id, payload);
        this.showSuccessMessage('Task updated successfully');
        this.$router.push({ path: `/pages/scheduled-tasks` })
        await vue.$parent.refreshData();
        this.open = false;
      } catch (e) {
        this.$vs.loading.close('#task-view > .con-vs-loading')
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close('#task-view > .con-vs-loading')
    },
    onSearch(search, loading) {
      if (search.length) {
        loading(true);
        this.searchStaff(loading, search, this);
      }
    },
    onSearchTemplate(search, loading) {
      if (search.length) {
        loading(true);
        this.searchTemplates(loading, search, this);
      }
    },
    async getStaffList(departmentIds = []) {
      let query = `filter[is_active]=1`;
      
      if (departmentIds.length > 0) {
        // example: filter[departments]=1,2,3
        query += `&filter[department-ids]=${departmentIds.join(',')}`;
      }
      const { data: staffResponse } = await DropDownRepository.getStaffList(query);

      this.staffs = staffResponse.data;
    },
    onClickBack() {
      this.$router.push({ path: `/pages/settings?tab=staff+scheduled_task_templates` })
    },
    async getDepartments() {
      const { data } = await DepartmentsRepository.get(' ', '', '', '')
      this.departments = data.data
    },
    toIds(arr) {
      return Array.isArray(arr)
        ? arr.map(item => (typeof item === 'object' && item !== null ? item.id : item))
        : [];
    },
    async getFrequencies() {
      try {
        const { data } = await ScheduledTasksRepository.frequencies();
        this.frequencies = data.data.sort((a, b) => a.label.localeCompare(b.label));
      } catch (err) {
        console.error("Failed to load frequencies:", err);
      }
    },
    async getAllocations() {
      try {
        const { data } = await ScheduledTasksRepository.allocations();
        // create a new array so Vue detects the change
        this.allocations = data.data.sort((a, b) => a.label.localeCompare(b.label));
      } catch (err) {
        console.error("Failed to load allocations:", err);
      }
    },
  },
  computed: {
    flatPkrConfigDisabled() {
      return {
        dateFormat: 'd/m/Y',
        allowInput: false, // disables typing
        clickOpens: false, // disables calendar popup
      }
    },
    flatPkrConfig() {
      return {
        dateFormat: 'd/m/Y',
      }
    }
  },
  watch: {
  'form.departments': {
    async handler(newVal) {
      // Reset selected staff if needed
      // this.form.staff = null;

      let deptsToSearch = newVal.map(item => {
      if(item.id){
        return item.id
      }
      else {
      return item
      }
      })
      // Call your API
      await this.getStaffList(deptsToSearch);
    },
    deep: true
  }
  },
}
</script>
<style>
.taskBox {
  border: solid 2px;
  border-radius: 8px;
  padding: 20px 20px 40px 20px;
  margin: 40px 0px;
}

.taskBox:first-child {
  margin-top: 20px;
}
</style>
